var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Radial Bar Chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 148",
    d: "M1 37C1 56.8823 17.1177 73 37 73C56.8823 73 73 56.8823 73 37C73 17.1177 56.8823 1 37 1",
    stroke: "url(#paint0_linear_3215_5251)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 149",
    d: "M37.0002 8.19995C52.906 8.19995 65.8002 21.0942 65.8002 37C65.8002 52.9058 52.906 65.8 37.0002 65.8C29.3307 65.8 22.3614 62.802 17.2002 57.9142",
    stroke: "url(#paint1_linear_3215_5251)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 150",
    d: "M37 58.6C48.9293 58.6 58.6 48.9294 58.6 37C58.6 25.0707 48.9293 15.4 37 15.4",
    stroke: "url(#paint2_linear_3215_5251)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 151",
    d: "M37 22.6C44.9529 22.6 51.4 29.0471 51.4 37C51.4 41.3009 49.5145 45.1614 46.525 47.8",
    stroke: "url(#paint3_linear_3215_5251)",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3215_5251",
    x1: 1,
    y1: 37,
    x2: 73,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3215_5251",
    x1: 17.2002,
    y1: 36.9999,
    x2: 65.8002,
    y2: 36.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3215_5251",
    x1: 37,
    y1: 37,
    x2: 58.6,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3215_5251",
    x1: 37,
    y1: 35.2,
    x2: 51.4,
    y2: 35.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.e18c0ade1357a543343db522aea5f5b3.svg";
export { ForwardRef as ReactComponent };